module.exports = __webpack_public_path__ + "7cdfc3f5b1effa4ae5011a43c4ea7362.svg";